import { IPuzzleV1 } from "../dataLayer/v1/interfaces/classes/IPuzzleV1";

export function getPuzzleTimeRemainingInSeconds(puzzle: IPuzzleV1): number {
  return Math.max(0, puzzle.timeLimitInSeconds - puzzle.timeElapsedInSeconds);
}

export function hasPuzzleTimeExpired(puzzle: IPuzzleV1): boolean {
  return getPuzzleTimeRemainingInSeconds(puzzle) === 0;
}
